import { render, staticRenderFns } from "./NonModalDialog.vue?vue&type=template&id=4046eb9a&scoped=true"
import script from "./NonModalDialog.vue?vue&type=script&lang=js"
export * from "./NonModalDialog.vue?vue&type=script&lang=js"
import style0 from "./NonModalDialog.vue?vue&type=style&index=0&id=4046eb9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4046eb9a",
  null
  
)

export default component.exports